module.exports = __webpack_public_path__ + "static/media/m-operator-img-001.5296f974.jpg";